import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { createPortal } from 'react-dom';
import styled, { useTheme } from 'styled-components';
import { th } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Flyout = function Flyout(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children;

  var _useState = useState(false),
      hydrated = _useState[0],
      setHydrated = _useState[1];

  var theme = useTheme();
  var flyoutWidth = theme.sizes.flyoutWidth;
  var transitionTime = theme.transitionDuration.interaction;
  useEffect(function () {
    setHydrated(true);
  }, []); // Must be different from no-scroll to open modals and flyouts at the same time

  var noScrollClass = 'no-scroll-flyout';
  useEffect(function () {
    if (!isOpen) {
      setTimeout(function () {
        return document.body.classList.remove(noScrollClass);
      }, transitionTime);
    } else {
      document.body.classList.add(noScrollClass);
    }

    return function () {
      return document.body.classList.remove(noScrollClass);
    };
  }, [isOpen, transitionTime]);

  if (!hydrated) {
    // Returns null on first render, so the client and server match
    return null;
  }

  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsxs(Outter, {
    children: [/*#__PURE__*/_jsx(PageCover, {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: isOpen ? 0.5 : 0
      },
      transition: {
        type: 'ease-in-out',
        duration: transitionTime / 1000
      },
      onClick: function onClick() {
        return onClose();
      },
      "data-testid": "flyout-page-cover",
      $enableEvents: isOpen,
      role: "presentation"
    }), /*#__PURE__*/_jsx(StyledFlyout, {
      initial: {
        x: flyoutWidth
      },
      animate: {
        x: isOpen ? 0 : flyoutWidth
      },
      transition: {
        type: 'ease-in-out',
        duration: transitionTime / 1000
      },
      children: /*#__PURE__*/_jsx(FlyoutContent, {
        "data-testid": "parent-flyout",
        children: children
      })
    })]
  }), document.body);
};
var Outter = styled.div.withConfig({
  componentId: "sc-1c8mesc-0"
})(["position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:", ";"], th.getZIndex('modal'));
var StyledFlyout = styled(motion.div).withConfig({
  componentId: "sc-1c8mesc-1"
})(["position:fixed;right:0;top:0;bottom:0;pointer-events:all;z-index:", ";width:100%;max-width:min(", ",100%);background-color:", ";"], th.getZIndex('modal'), th.getSize('flyoutWidth'), th.getColor('base000'));
var PageCover = styled(motion.div).withConfig({
  componentId: "sc-1c8mesc-2"
})(["position:fixed;inset:0;background-color:", ";z-index:", ";pointer-events:", ";"], th.getColor('charcoal'), th.getZIndex('popover'), function (props) {
  return props.$enableEvents ? 'all' : 'none';
});
var FlyoutContent = styled.div.withConfig({
  componentId: "sc-1c8mesc-3"
})(["position:relative;overflow:hidden auto;height:100%;"]);